import { Lock } from "lucide-react";

export function ProBadge({
  className = "",
  label = "PRO",
  locked = false,
}: {
  className?: string;
  label?: string;
  locked?: boolean;
}) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-amber-200 to-amber-100 px-1.5 py-0.5 text-[10px] font-bold text-amber-900 ring-1 ring-inset ring-amber-400/40 shadow-2xs select-none ${className}`}
    >
      {locked ? (
        <Lock className="h-2.5 w-2.5 text-amber-800 shrink-0" />
      ) : (
        <span className="text-[9px] leading-none">✦</span>
      )}
      <span>{label}</span>
    </span>
  );
}
